import React from 'react';

export const MusicNoteIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            version="1.1"
            viewBox="0 0 5.821 5.821"
        >
            <g strokeWidth="0.529">
                <circle
                    cx="1.455"
                    cy="4.63"
                    r="0.661"
                    fill="#fff"
                    fillOpacity="1"
                ></circle>
                <circle
                    cx="3.836"
                    cy="4.63"
                    r="0.661"
                    fill="#fff"
                    fillOpacity="1"
                ></circle>
                <path
                    fill="none"
                    stroke="#fff"
                    strokeDasharray="none"
                    strokeLinecap="butt"
                    strokeLinejoin="miter"
                    strokeMiterlimit="4"
                    strokeOpacity="1"
                    d="M1.852 2.956v-.397l2.381-.53v1.192"
                ></path>
                <path
                    fill="none"
                    stroke="#fff"
                    strokeDasharray="none"
                    strokeLinecap="butt"
                    strokeLinejoin="miter"
                    strokeMiterlimit="4"
                    strokeOpacity="1"
                    d="M1.852 4.63V1.588l2.381-.53V4.63"
                ></path>
            </g>
        </svg>
    );
};
